import React from 'react';
import { motion } from 'framer-motion';
import { CtaSection } from './CtaSection';
export function HeroSection() {
  return <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 px-4 overflow-hidden" style={{
    backgroundColor: '#080808'
  }} data-id="element-91">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[400px] blur-[120px] rounded-full pointer-events-none" style={{
      background: 'rgba(0, 242, 255, 0.06)'
    }} data-id="element-92" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-[600px] h-[300px] blur-[100px] rounded-full pointer-events-none" style={{
      background: 'rgba(197, 160, 89, 0.04)'
    }} data-id="element-93" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-94">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-95">
          {/* Left Side — Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-96">
            <div className="inline-block mb-5 px-4 py-1.5 rounded-full border border-[#00F2FF]/30 bg-[#00F2FF]/10 text-sm font-semibold tracking-widest uppercase" style={{
            color: '#00F2FF'
          }} data-id="element-97">
              Elite Mastery Bundle 2026
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 tracking-tight" style={{
            color: '#C5A059',
            fontFamily: "'Space Grotesk', sans-serif"
          }} data-id="element-98">
              How to Force a 750+ Credit Score in 30 Days Without Paying
              Expensive Lawyers
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" style={{
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-99">
              The only "Data Re-Engineering" System that bypasses AI-Bureaus and
              gives you access to{' '}
              <strong className="text-white font-bold" data-id="element-100">
                $50,000 in 0% interest capital
              </strong>
              .
            </p>

            <div className="hidden lg:block" data-id="element-101">
              <CtaSection showTrustBadges={true} className="items-start" data-id="element-102" />
            </div>
          </motion.div>

          {/* Right Side — Product Image with Cyan Glow */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 w-full max-w-lg lg:max-w-xl relative flex items-center justify-center" data-id="element-103">
            {/* Cyan glow behind the image */}
            <div className="absolute inset-0 rounded-3xl blur-[60px] opacity-40 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at center, rgba(0, 242, 255, 0.35), transparent 70%)'
          }} data-id="element-104" />

            <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-gradient-to-b from-white/5 to-transparent p-2" style={{
            boxShadow: '0 8px 60px rgba(0, 242, 255, 0.25), 0 2px 20px rgba(0, 242, 255, 0.15)'
          }} data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/mZmLXpvyqVqfwFv9mynEds/heylloyd-image-1775160656545.png" alt="Elite Mastery Bundle 2026 — Credit Architecture" className="w-full h-auto rounded-xl object-cover" data-id="element-106" />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/30 via-transparent to-[#00F2FF]/5 rounded-xl pointer-events-none" data-id="element-107" />
            </div>
          </motion.div>

          {/* Mobile CTA */}
          <div className="w-full lg:hidden mt-4" data-id="element-108">
            <CtaSection showTrustBadges={true} data-id="element-109" />
          </div>
        </div>
      </div>
    </section>;
}